// Crédits IA achetables — solde, catalogue de packs et vérification d'achat.
// Le catalogue et le solde vivent côté api-postgres ; le checkout passe par
// api-stripe (voir stripeService.createAiCreditCheckout).
import apiClient from "./apiClient";

export interface AiCreditPack {
  id: string;
  name: string;
  description: string | null;
  priceEur: number;
  priceCents: number;
  creditsUsd: number;
  creditsMicroCents: number;
  isActive: boolean;
  displayOrder: number;
}

export interface AiCreditBalance {
  balanceUsd: number;
  balanceMicroCents: number;
  totalPurchasedUsd: number;
}

export interface AiCreditTransaction {
  id: string;
  type: "purchase" | "debit";
  amountUsd: number;
  balanceAfterUsd: number | null;
  packName: string | null;
  priceEur: number | null;
  periodMonth: string | null;
  createdAt: string;
}

export const aiCreditsService = {
  getPacks: async (): Promise<AiCreditPack[]> => {
    const res = await apiClient.get("/api/ai-credits/packs");
    return res.data.data;
  },

  getBalance: async (): Promise<AiCreditBalance> => {
    const res = await apiClient.get("/api/ai-credits/me");
    return res.data.data;
  },

  getHistory: async (opts?: {
    limit?: number;
    offset?: number;
    includeDebits?: boolean;
  }): Promise<AiCreditTransaction[]> => {
    const res = await apiClient.get("/api/ai-credits/me/history", {
      params: opts,
    });
    return res.data.data;
  },

  // Ceinture-bretelles de la page succès : crédite immédiatement si le
  // webhook Stripe n'est pas encore passé (idempotent côté backend).
  verifyCreditSession: async (
    sessionId: string,
  ): Promise<{ credited: boolean; balance: AiCreditBalance }> => {
    const res = await apiClient.post("/api/ai-credits/verify-session", {
      sessionId,
    });
    return { credited: res.data.credited, balance: res.data.data };
  },
};
